import React, { ChangeEvent, FunctionComponent } from 'react'
import { UseFormSetValue } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { IBlockedCategory } from '../../../../types'
import {
  AddBlockedCategoryButton,
  AddBlockedCategoryButtonIcon,
} from '../../../BlockForm/style'
import { InputWrapper } from '../InputWrapper'

interface IProps {
  setValue: UseFormSetValue<any>
  blockCategories: IBlockedCategory[]
  isInputFieldOpen: boolean
  setIsInputFieldOpen: (isInputFieldOpen: boolean) => void
}

export const AppointmentBlockedCategory: FunctionComponent<IProps> = ({
  setValue,
  blockCategories,
  isInputFieldOpen,
  setIsInputFieldOpen,
}) => {
  const { t } = useTranslation()

  const handleCategorySelect = (e: ChangeEvent<HTMLSelectElement>) => {
    e.preventDefault()
    const selectedValue = e.target.value.split('|')
    setValue('blockedCategoryUuid', selectedValue[0])
    setValue('blockDuration', selectedValue[1])
  }

  const CategoryListMap: JSX.Element[] = blockCategories.map(
    (category, index) => {
      if (index === 0) {
        setValue('blockedCategoryUuid', category.uuid)
        setValue('blockDuration', category.duration)
      }

      return (
        <option
          selected={index === 0}
          value={`${category.uuid}|${category.duration}`}
          key={category.uuid}>
          {category.name}
        </option>
      )
    },
  )

  // TODO Style
  return (
    <InputWrapper>
      <select
        // fieldLabel={t('Blocked category')}
        // fieldColor="#005cd9"
        // optionsArray={CategoryListMap}
        // customWidth="400px"
        onChange={e => handleCategorySelect(e)}>
        {CategoryListMap}
      </select>
      <AddBlockedCategoryButton
        onClick={() => setIsInputFieldOpen(!isInputFieldOpen)}>
        <AddBlockedCategoryButtonIcon icon="plus" />
      </AddBlockedCategoryButton>
    </InputWrapper>
  )
}
